import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import i18n, { isSupportedLanguage, T_AppLanguage } from "../../config/i18n";

export interface T_LanguageState {
  activeLanguage: T_AppLanguage;
  isProfileApiCalled: boolean;
}

export const LanguageSliceKey = "LanguageSlice";

export function syncI18nLanguage(lang: T_AppLanguage): void {
  void i18n.changeLanguage(lang);
}

const initialState: T_LanguageState = {
  activeLanguage: "en",
  isProfileApiCalled: false,
};

const LanguageSlice = createSlice({
  name: LanguageSliceKey,
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<string>) => {
      if (!isSupportedLanguage(action.payload)) {
        if (process.env.NODE_ENV === "development") {
          console.warn(
            `[LanguageSlice] Unsupported language code "${action.payload}" - ignoring.`,
          );
        }
        return state;
      }
      state.activeLanguage = action.payload;
      syncI18nLanguage(action.payload);
      return state;
    },
    setIsProfileApiCalled: (state, action: PayloadAction<boolean>) => {
      state.isProfileApiCalled = action.payload;
      return state;
    },
  },
});

export const LanguageSliceReducer = LanguageSlice.reducer;
export const { setLanguage, setIsProfileApiCalled } = LanguageSlice.actions;

export const selectActiveLanguage = (
  state: Record<typeof LanguageSliceKey, T_LanguageState>,
) => state[LanguageSliceKey].activeLanguage;
